import Backend from 'shared/lib/Backend';
import sectionTools from 'fantastic/lib/sections';

const dispatchStartSaving = dispatch => dispatch({ type: 'START_SAVING' });
const dispatchFinishSaving = dispatch => dispatch({ type: 'FINISH_SAVING' });

export default (id) => async (dispatch, getState) => {
  const { id, style_attributes } = getState().theme;
  dispatchStartSaving(dispatch);
  const body = JSON.stringify({ theme_id: id, theme: style_attributes });
  const response = await Backend.requestJson(`${window.location.pathname}/update_theme`, { body }, "PUT");
  dispatchFinishSaving(dispatch);
  const { sections, theme: { style_attributes: currentStyleAttributes } } = getState();
  const clearedSections = JSON.parse(JSON.stringify(sections));
  sectionTools.prepareForSave(clearedSections);
  const snapshot = JSON.stringify({ sections: clearedSections, theme: currentStyleAttributes });
  dispatch({ type: 'VERSIONS/PUSH', payload: { newSnapshot: snapshot } });
};

